const colors = {
  transparent: "transparent",
  black: "#000",
  white: "#fff",
  grey1: "#f7fafc",
  grey2: "#edf2f7",
  grey3: "#e2e8f0",
  grey4: "#cbd5e0",
  grey5: "#a0aec0",
  grey6: "#718096",
  grey7: "#4a5568",
  grey8: "#2d3748",
  grey9: "#1a202c",
  red1: "#fff5f5",
  red2: "#fed7d7",
  red3: "#feb2b2",
  red4: "#fc8181",
  red5: "#f56565",
  red6: "#e53e3e",
  red7: "#c53030",
  red8: "#9b2c2c",
  red9: "#742a2a",
  orange1: "#fffaf0",
  orange2: "#feebc8",
  orange3: "#fbd38d",
  orange4: "#f6ad55",
  orange5: "#ed8936",
  orange6: "#dd6b20",
  orange7: "#c05621",
  orange8: "#9c4221",
  orange9: "#7b341e",
  yellow1: "#fffff0",
  yellow2: "#fefcbf",
  yellow3: "#faf089",
  yellow4: "#f6e05e",
  yellow5: "#ecc94b",
  yellow6: "#d69e2e",
  yellow7: "#b7791f",
  yellow8: "#975a16",
  yellow9: "#744210",
  green1: "#f0fff4",
  green2: "#c6f6d5",
  green3: "#9ae6b4",
  green4: "#68d391",
  green5: "#48bb78",
  green6: "#38a169",
  green7: "#2f855a",
  green8: "#276749",
  green9: "#22543d",
  teal1: "#e6fffa",
  teal2: "#b2f5ea",
  teal3: "#81e6d9",
  teal4: "#4fd1c5",
  teal5: "#38b2ac",
  teal6: "#319795",
  teal7: "#2c7a7b",
  teal8: "#285e61",
  teal9: "#234e52",
  blue1: "#ebf8ff",
  blue2: "#bee3f8",
  blue3: "#90cdf4",
  blue4: "#63b3ed",
  blue5: "#4299e1",
  blue6: "#3182ce",
  blue7: "#2b6cb0",
  blue8: "#2c5282",
  blue9: "#2a4365",
  indigo1: "#ebf4ff",
  indigo2: "#c3dafe",
  indigo3: "#a3bffa",
  indigo4: "#7f9cf5",
  indigo5: "#667eea",
  indigo6: "#5a67d8",
  indigo7: "#4c51bf",
  indigo8: "#434190",
  indigo9: "#3c366b",
  purple1: "#faf5ff",
  purple2: "#e9d8fd",
  purple3: "#d6bcfa",
  purple4: "#b794f4",
  purple5: "#9f7aea",
  purple6: "#805ad5",
  purple7: "#6b46c1",
  purple8: "#553c9a",
  purple9: "#44337a",
  pink1: "#fff5f7",
  pink2: "#fed7e2",
  pink3: "#fbb6ce",
  pink4: "#f687b3",
  pink5: "#ed64a6",
  pink6: "#d53f8c",
  pink7: "#b83280",
  pink8: "#97266d",
  pink9: "#702459",
}

const space = {
  "0": "0",
  "1": "0.25rem",
  "2": "0.5rem",
  "3": "0.75rem",
  "4": "1rem",
  "5": "1.25rem",
  "6": "1.5rem",
  "8": "2rem",
  "10": "2.5rem",
  "12": "3rem",
  "16": "4rem",
  "20": "5rem",
  "24": "6rem",
  "32": "8rem",
  "40": "10rem",
  "48": "12rem",
  "56": "14rem",
  "64": "16rem",
}

const borders = {
  "0": "0",
  "1": "1px",
  "2": "2px",
  "4": "4px",
  "8": "8px",
}

const breakpoints = ["640px", "768px", "1024px", "1280px"]

breakpoints.sm = breakpoints[0]
breakpoints.md = breakpoints[1]
breakpoints.lg = breakpoints[2]
breakpoints.xl = breakpoints[3]

export default {
  colors,
  space,
  borders: Object.keys(borders).reduce((curr, acc) => {
    Object.keys(colors).forEach(color => {
      curr[`${acc}:${color}`] = `${borders[acc]} solid ${colors[color]}`
    })
    return curr
  }, {}),
  breakpoints,
  fonts: {
    sans: ["Roboto", "-apple-system", "sans-serif", '"Helvetica Neue"'],
    serif: ["Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
    mono: [
      "Menlo",
      "Monaco",
      "Consolas",
      '"Liberation Mono"',
      '"Courier New"',
      "monospace",
    ],
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "4rem",
  },
  fontWeight: {
    hairline: "100",
    thin: "200",
    light: "300",
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
    black: "900",
  },
  lineHeight: {
    none: "1",
    tight: "1.25",
    snug: "1.375",
    normal: "1.5",
    relaxed: "1.625",
    loose: "2",
  },
  letterSpacing: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },
  backgroundPosition: {
    bottom: "bottom",
    center: "center",
    left: "left",
    "left-bottom": "left bottom",
    "left-top": "left top",
    right: "right",
    "right-bottom": "right bottom",
    "right-top": "right top",
    top: "top",
  },
  backgroundSize: {
    auto: "auto",
    cover: "cover",
    contain: "contain",
  },
  borderRadius: {
    none: "0",
    sm: "0.125rem",
    md: "0.25rem",
    lg: "0.5rem",
    full: "9999px",
  },
  widths: {
    auto: "auto",
    ...space,
    full: "100%",
    screen: "100vw",
    fit: "fit-content",
  },
  heights: {
    auto: "auto",
    ...space,
    full: "100%",
    screen: "100vh",
  },
  minWidths: {
    "0": "0",
    ...space,
    full: "100%",
  },
  minHeights: {
    "0": "0",
    full: "100%",
    screen: "100vh",
  },
  maxWidths: {
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    full: "100%",
  },
  maxHeights: {
    full: "100%",
    screen: "100vh",
  },
  objectPosition: {
    bottom: "bottom",
    center: "center",
    left: "left",
    "left-bottom": "left bottom",
    "left-top": "left top",
    right: "right",
    "right-bottom": "right bottom",
    "right-top": "right top",
    top: "top",
  },
  shadows: {
    sm: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.5)",
    none: "none",
  },
  zIndices: {
    auto: "auto",
    "0": "0",
    "10": "10",
    "20": "20",
    "30": "30",
    "40": "40",
    "50": "50",
  },
  opacity: {
    "0": "0",
    "25": "0.25",
    "50": "0.5",
    "75": "0.75",
    "100": "1",
  },
  flex: {
    "1": "1 1 0%",
    auto: "1 1 auto",
    initial: "0 1 auto",
    none: "none",
  },
  flexGrow: {
    "0": "0",
    default: "1",
  },
  flexShrink: {
    "0": "0",
    default: "1",
  },
  order: {
    first: "-1",
    last: "999",
    none: "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
  },
  listStyleType: {
    none: "none",
    disc: "disc",
    decimal: "decimal",
  },
}
